import PasswordTextField from "ui/common/components/input/PasswordTextField/PasswordTextField";
import useTranslate from "ui/locale/hooks/useTranslate";
import { ConfirmPasswordFieldsProps } from "./ConfirmPasswordFields.types";
import { useControlled } from "@commonlibs";

const ConfirmPasswordFields = ({
    confirmPassword,
    showControl = true,
    labelPassword = "",
    validatePassword,
    defaultValue = "",
    value,
    onChange,
    name,
    disabled,
    required = true,
    readonly,
}: ConfirmPasswordFieldsProps) => {
    const [password, setPassword] = useControlled(defaultValue, value, onChange);
    const translate = useTranslate();

    return (
        <>
            <PasswordTextField
                label={labelPassword !== "" ? labelPassword : translate("password")}
                name={confirmPassword ? "root-password" : name}
                value={password}
                onChange={setPassword}
                validatePassword={validatePassword}
                required={required}
                disabled={disabled}
                readonly={readonly}
                showControl={showControl}
                placeholder={translate("passwordTextPlaceholder")}
            />
            {confirmPassword && (
                <PasswordTextField
                    name={confirmPassword ? name : "root-confirmPassword"}
                    showControl={false}
                    label={translate("confirmPassword")}
                    placeholder={translate("repeatPasswordTextPlaceholder")}
                    required={required}
                    disabled={disabled}
                    readonly={readonly}
                    hideError={false}
                    validatePassword={false}
                    validators={{ eq: [password, translate("passwordsDoNotMatch", { ns: "error", defaultValue: "error" })] }}
                />
            )}
        </>
    );
};

export default ConfirmPasswordFields;
